import { Routes, Route, Navigate } from "react-router-dom";
import { RequireAuth } from "./RequireAuth.js";
import { RequireRole } from "./RequireRole.js";
import { LoginPage } from "../pages/login/LoginPage.js";
import { UtenzePage } from "../pages/utenze/UtenzePage.js";
import { KitPage } from "../pages/kit/KitPage.js";
import { RilevazioniPage } from "../pages/rilevazioni/RilevazioniPage.js";
import { AdminPage } from "../pages/admin/AdminPage.js";
import { ReportPage } from "../pages/report/ReportPage.js";
import { TurniPage } from "../pages/turni/TurniPage.js";
import { DashboardLayout } from "./DashboardLayout.js";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<Navigate to="/rilevazioni" replace />} />

          <Route path="/utenze" element={<UtenzePage />} />
          <Route path="/kit" element={<KitPage />} />
          <Route path="/rilevazioni" element={<RilevazioniPage />} />
          <Route path="/turni" element={<TurniPage />} />
          <Route path="/report" element={<ReportPage />} />

          <Route element={<RequireRole role="ADMIN" />}>
            <Route path="/admin" element={<AdminPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
